/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useQuery, gql } from '@apollo/client';

export const useCategory = (categoryID, skipCondition) => {

    const variables = 
        {
            "categoryId": categoryID
        }

    const GET_CATEGORY_DETAILS_GQL  = gql`
    query CategoryDetails( $categoryId: String) {
    category(id: $categoryId) {
        id
        name
        slug
        description
    }}`

    const {loading, data, error} = useQuery(GET_CATEGORY_DETAILS_GQL, {
        variables,
        fetchPolicy: 'network-only',
        skip: skipCondition
    });
    
    return {loading, data, error};

}